<template>
	<div
		id="description"
		class="cms-element-product-description-reviews flex flex-wrap pt-6 mt-2 mb-10 sm:mb-20 -mx-4 sm:mx-0 px-4 text-[15px] leading-[1.6]"
	>
		<ProductDetailsDesktop
			:description="currentTabDescription"
			:current-tab-specification="currentTabSpecification"
			class="hidden md:block lg:flex"
		/>

		<div class="block w-full md:hidden">
			<TabHeader
				:tabs="tabs"
				:current-tab-hash="currentTabHash"
				:change-tab="changeTab"
			/>
			<Tab
				:description="currentTabDescription"
				:current-tab-hash="currentTabHash"
				:current-tab-specification="currentTabSpecification"
			/>
		</div>
	</div>
</template>

<script setup lang="ts">
import { ref, watchEffect } from "vue";
import type { VariantParametric } from "@nwt/norce-pwa/dist/runtime/types/api/product/product";
import TabHeader from "./TabHeader.vue";
import Tab from "./Tab.vue";
import ProductDetailsDesktop from "./ProductDetailsDesktop.vue";

const { selectedProduct } = storeToRefs(useProductStore());
const { t } = useI18n();

const tabs = ref([
	{
		name: t("product.details.description"),
		value: ProductDetailsTabs.DESCRIPTION
	},
	{
		name: t("product.details.specifications"),
		value: ProductDetailsTabs.SPECIFICATION
	},
	{
		name: ProductDetailsTabs.DELIVERY_AND_RETURNS,
		value: ProductDetailsTabs.DELIVERY_AND_RETURNS
	}
]);

const currentTabHash = ref<string>(ProductDetailsTabs.DESCRIPTION);
const currentTabDescription = ref<string>();
const currentTabSpecification = ref<VariantParametric[]>();

const changeTab = (value: string) => {
	return (currentTabHash.value = value);
};

const setDefaultDetails = () => {
	currentTabDescription.value = selectedProduct?.value?.Description;
	currentTabDescription.value = selectedProduct?.value?.SubDescription;
	currentTabSpecification.value = selectedProduct?.value?.Parametrics.filter(
		({ Value, IsHidden }) => !!Value && !IsHidden
	);
};

setDefaultDetails();

const changeDescription = ({ currentTabHash }: { currentTabHash: string }) => {
	const currentTab = tabs.value.filter(
		(tab) => tab.value === currentTabHash
	)[0];

	if (currentTab) {
		if (currentTabHash === ProductDetailsTabs.DESCRIPTION) {
			return (currentTabDescription.value =
				selectedProduct?.value?.Description);
		}
		if (currentTabHash === ProductDetailsTabs.DELIVERY_AND_RETURNS) {
			return (currentTabDescription.value =
				selectedProduct?.value?.SubDescription);
		}
		if (currentTabHash === ProductDetailsTabs.SPECIFICATION) {
			return (currentTabSpecification.value =
				selectedProduct?.value?.Parametrics.filter(
					({ Value, IsHidden }) => !!Value && !IsHidden
				));
		}
	}
};
const handleIframes = () => {
	const youtubeIframes = document.querySelectorAll(
		'iframe[data-src*="https://www.youtube.com"]'
	);

	if (youtubeIframes.length === 0) return;

	youtubeIframes.forEach((iframe) => {
		const dataSrc = iframe.getAttribute("data-src");
		if (!dataSrc) return;

		iframe.classList.add("max-w-full");
		iframe.setAttribute("src", dataSrc);
	});
	window.removeEventListener("scroll", handleIframes);
};

onMounted(() => {
	window.addEventListener("scroll", handleIframes);
});

watchEffect(() => {
	changeDescription({ currentTabHash: currentTabHash.value });
});
</script>

<style scoped>
.cms-element-product-description-reviews :deep() p {
	@apply mb-5;
}

.cms-element-product-description-reviews :deep() h2:not(.heading) {
	@apply mb-1 text-base font-bold;
}

.cms-element-product-description-reviews :deep() h3 {
	@apply mb-1 text-base font-bold border-b border-gray-300;
}

.cms-element-product-description-reviews :deep() ul {
	@apply ml-4;
}

.cms-element-product-description-reviews :deep() li {
	@apply list-disc;
}
</style>
